import { Card, DataList, Flex, Text } from '@radix-ui/themes';
import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { formatDateForOutput } from '../../utils/dateFormatter';

const GENDERS: Record<string, string> = { M: 'Masculino', F: 'Feminino' };

export const UserPreview = () => {
  const userData = useSelector((state: RootState) => state.user);

  /**
   * O género só é conhecido quando vem preenchido: antes, um registo sem
   * género era apresentado como "Feminino" por omissão.
   */
  const gender = userData?.gender ? GENDERS[userData.gender] : undefined;

  const fields: { label: string; value?: string | null }[] = [
    { label: 'Nome', value: userData?.name },
    { label: 'Utilizador', value: userData?.userName },
    { label: 'Email', value: userData?.email },
    { label: 'Documento de identificação', value: userData?.bi },
    { label: 'NUIT', value: userData?.nuit },
    { label: 'Telefone', value: userData?.phoneNumber },
    {
      label: 'Data de nascimento',
      value: userData?.dateOfBirth ? formatDateForOutput(userData.dateOfBirth) : undefined,
    },
    { label: 'Género', value: gender },
  ];

  return (
    <Flex direction="column" gap="4">
      <Card size="3">
        <DataList.Root orientation={{ initial: 'vertical', sm: 'horizontal' }}>
          {fields.map(({ label, value }) => (
            <DataList.Item key={label}>
              <DataList.Label minWidth="180px">{label}</DataList.Label>
              <DataList.Value>
                {value ? (
                  <Text weight="medium">{value}</Text>
                ) : (
                  <Text color="gray">N/A</Text>
                )}
              </DataList.Value>
            </DataList.Item>
          ))}
        </DataList.Root>
      </Card>
    </Flex>
  );
};
